import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Col, Row, Typography } from "antd";

import PatientSelfEvaluationsAsignedTable from "../../../components/Tables/PatientSelfEvaluationsAsignedTable";
import PatientSelfEvaluationAnswersTable from "../../../components/Tables/PatientSelfEvaluationAnswersTable";
import { Link, useParams } from "react-router-dom";
import { translate } from "../../../locale";
import AssociateSurveyUser from "../../../components/Modals/AssociateSurveyUser";

const { Title } = Typography;

const SelfEvaluations = () => {
  const { username } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [reloadTable, setReloadTable] = useState(0);

  const handleComplete = () => {
    setShowModal(false);
    setReloadTable((v) => v + 1);
  };
  const handleCancel = () => {
    setShowModal(false);
  };
  return (
    <div className="flex flex-col items-start min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row gutter={16} className="w-full">
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Autoevaluación")}</Breadcrumb.Item>
          </Breadcrumb>
          <Breadcrumb>
            <Breadcrumb.Item>{username}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Autoevaluaciones")}
          </Title>
        </Col>
      </Row>
      <div className="flex flex-col justify-center items-center w-full my-4 bg-gray-200">
        <Title level={3} className="mt-4">
          RESPONDIDAS
        </Title>
      </div>

      <div className="flex justify-center w-full mt-4">
        <PatientSelfEvaluationAnswersTable />
      </div>

      <div className="flex flex-col justify-center items-center w-full mt-10 mb-4 bg-gray-200">
        <Title level={3} className="mt-4">
          ASIGNADAS
        </Title>
      </div>

      <Button
        type="primary"
        className="px-10 bg-white text-black"
        onClick={() => setShowModal(true)}
      >
        {translate("Asignar autoevaluación")}
      </Button>
      <AssociateSurveyUser
        username={username}
        visible={showModal}
        onComplete={handleComplete}
        onCancel={handleCancel}
      />

      <div className="flex justify-center w-full mt-4">
        <PatientSelfEvaluationsAsignedTable reload={reloadTable} />
      </div>
    </div>
  );
};

export default SelfEvaluations;
